<template>
  <div class="hello">
    <section class="main_section"></section>

    <section class="pa-5 bg--white">
      <v-row class="text-xs-left">
        <v-col sm4>
          <img src="~../assets/images/pic_02.jpg" width="100%" class="hidden-sm-and-down" />
        </v-col>
        <v-col sm8>
          <v-row>
            <v-col sm8>
              <img src="~../assets/images/modern.svg" width="100%" />
              <p style="font-size: 2em; margin-top: -0.5em;">暢遊臺中 - 魅力城市</p>
            </v-col>
            <v-col sm4 class="text-xs-center hidden-md-and-down">
              <img src="~../assets/images/using_tip.svg" width="140" style="margin-top: 1em;" />
            </v-col>
          </v-row>

          <v-row class="float-description hidden-md-and-down">
            <v-col sm12>一本專為國人打造的旅遊英語教材，讓你大玩特玩學英語！擁有本書讓你馬上變身專業英語導遊、成為最稱職的國民外交家！</v-col>
          </v-row>

          <v-row class="hidden-lg-and-up">
            <v-col sm12 mb-3 pa-3>
              <span class="sub-title">Using Tips</span>
              <p class="sub-content">一本專為國人打造的旅遊英語教材，讓你大玩特玩學英語！擁有本書讓你馬上變身專業英語導遊、成為最稱職的國民外交家！</p>
            </v-col>
          </v-row>

          <v-row>
            <v-col sm6 pa-4>
              <v-row>
                <v-col xs12>
                  <span class="sub-title">景點介紹</span>
                  <p class="sub-content">景點介紹內容採中英對照，下方會提示重點單字。讀者可清楚了解該景點的歷史、文化、由來等相關資訊，加深對景點的印象，進一步自我練習。</p>
                </v-col>
              </v-row>
            </v-col>

            <v-col sm6 pa-4>
              <v-row>
                <v-col xs12>
                  <span class="sub-title">實景會話</span>
                  <p class="sub-content">實景會話透過中外籍老師實地走訪該景點，對話內容的臨場感與心情感受，都是在旅遊時會用到的實用句型。另外也補充貼心小知識給讀者參考。</p>
                </v-col>
              </v-row>
            </v-col>

            <v-col sm6 pa-4>
              <v-row>
                <v-col xs12>
                  <span class="sub-title">周邊旅遊資訊</span>
                  <p class="sub-content">週邊旅遊資訊提供主景點附近有關的各種旅遊資訊，以及特色店家的最新消息。不過提醒讀者們前往時，還是要與店家確定營業時間喔。</p>
                </v-col>
              </v-row>
            </v-col>

            <v-col sm6 pa-4>
              <v-row>
                <v-col xs12>
                  <span class="sub-title">學習音檔MP3</span>
                  <p class="sub-content">學習音檔MP3本書提倡環保，因此不提供音檔光碟。在這裡要麻煩各位讀者到我們提供的<span><a v-on:click="$router.push('/mp3')">下載網頁</a></span>，尋找並下載書中的課程與音檔。</p>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </section>

     <section class="pa-5 bg--primary">
      <v-row class="text-xs-left">
        <v-col offset-sm1 sm3>
          <p>關於我們</p>
          <p>
            LiveABC互動英語教學集團創立以來持續研發數位內容，每月持續發行雜誌、叢書、教科書等出版品，目前已經累積超過千本的數位語言學習產品，內容包含兒童美語、檢測英語、商業英語、文法寫作、生活會話、華語學習等豐富主題，可滿足各階段的學習需求。
          </p>
        </v-col>
        <v-col offset-sm1 sm3>
          <p>相關連結</p>
          <p><a href="http://www.liveabc.com">LiveABC互動英語</a></p>
          <p><a href="https://www.youtube.com/channel/UC_oJU8ulza90Njx5zVb2hCw">LiveABC互動英語 - Youtube</a></p>
          <p><a href="https://www.facebook.com/LiveABC/">LiveABC互動英語 - Facebook</a></p>
          <p><a href="http://www.pubu.com.tw/store/12341">LiveABC的書店 - Pubu電子書城</a></p>
        </v-col>
      </v-row>
     </section>
  </div>
</template>

<script>
export default {

  name: 'Book',

  data () {
    return {

    }
  }
}
</script>

<style lang="scss" scoped>
  .main_section {
    height: 70vh;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: 50% 50%;
    background-image: url('~../assets/images/pci_01.jpg');
  }

  .bg--primary {
    background-color: #f1f2f3 !important;
    color: #666666 !important;
    h4 {
      color: #666666 !important;
    }
  }

  .bg--white {
    background-color: #fff !important;
    color: #4a4a66 !important;
    h4 {
      color: #4a4a66 !important;
    }
  }

  .float-description {
    margin-left: -20%;
    margin-right: 55%;
    background-color: #7e70ae;
    opacity: .8;
    color: white;
    padding: 0.5em;
    font-size: 1.8em;
  }

  .sub-title {
    font-size: 1.8em;
    color: #7e70ae;
    font-weight: bold;
  }

  .sub-content {
    border-left: solid 1px #000;
    padding-left: 1em;
    padding-top: 1em;
    color: #666666;
    font-size: 1.6em;
    span {
      font-size: 1.2em;
      a {
        cursor: pointer;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// Book.vue?89414b00